<style scoped>
.bubble {
    position: relative;
    min-height: 2rem;
}
.bubble-point {
    position: absolute;
}
.bubble-point-left {
    left: 1px;
    transform: translateX(-100%);
}
.bubble-point-right {
    right: 1px;
    transform: translateX(100%) scale(-1, 1);
}
.bubble-point.point-down {
    bottom: 5px;
}
.border-darkGrayishBlue ::v-deep .bubble-point {
    color: theme('colors.indigo');
}
.border-blue ::v-deep .bubble-point {
    color: theme('colors.blue');
}
.border-red ::v-deep .bubble-point {
    color: theme('colors.red');
}
</style>

<template>
    <div
        class="inline-flex"
        :class="{
            'flex-row': imagePosition === 'left',
            'flex-row-reverse': imagePosition === 'right'
        }"
    >
        <div
            class="inline-block flex-shrink-0"
            :class="{
                'self-end': arrowStyle === 'point-down',
                'self-center': arrowStyle === 'center'
            }"
        >
            <slot name="image">
                <img :src="melsonImg" class="w-20" />
            </slot>
        </div>
        <div
            class="bubble self-center border bg-white flex items-center justify-center rounded-lg flex-auto shadow"
            :class="[
                borderClass,
                {
                    'mb-2': arrowStyle === 'point-down',
                    'ml-8': imagePosition === 'left',
                    'mr-8': imagePosition === 'right'
                }
            ]"
        >
            <div
                class="w-8 h-4 bubble-point"
                :class="[
                    arrowStyle,
                    {
                        'bubble-point-left': imagePosition === 'left',
                        'bubble-point-right': imagePosition === 'right'
                    }
                ]"
            >
                <svg
                    viewBox="0 0 20 20"
                    preserveAspectRatio="none"
                    class="w-full h-full stroke-current"
                >
                    <path
                        v-if="arrowStyle === 'point-down'"
                        d="M 20 0 L 1 20 L 20 19"
                        fill="white"
                    />
                    <path
                        v-if="arrowStyle === 'center'"
                        d="M 20 0 L 1 10 L 20 20"
                        fill="white"
                    />
                </svg>
            </div>
            <div class="px-2 sm:px-4 py-2">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import melsonImg from '../assets/img/melson.png';
export default {
    created() {
        this.melsonImg = melsonImg;
    },
    props: {
        borderClass: { type: String, default: 'border-darkGrayishBlue' },
        arrowStyle: { default: 'center' },
        imagePosition: { type: String, default: 'left' }
    }
};
</script>
